export default __webpack_public_path__ + "static/media/upload.416e0a78.svg";